import en from './en.json';
import kh from './kh.json';
const messages = {
    en: en,
    kh: kh
};
export default messages;
